import { i18n } from '@/i18n-config';
import { useParams } from 'next/navigation';
import { de, enUS } from 'date-fns/locale';

export default function useAppLocale() {
  const params = useParams();
  const [lang, countryCode] =
    typeof params.locale === 'string'
      ? params.locale.split('-')
      : i18n.defaultLocale.split('-');

  const langMap = {
    de: de,
    en: enUS,
  };

  let customerEndDateLocale: any;

  if (lang) {
    customerEndDateLocale = lang == 'de' ? langMap.de : langMap.en;
  }

  return { lang, countryCode, locale: params.locale, customerEndDateLocale };
}
